import mainList from './mainList.vue';
import additionalList from './additionalList.vue';
export default {
  components: {
    mainList,
    additionalList
  },
  data() {
    return {
      current: 0
    };
  },
  created() {
    if (sessionStorage.getItem('insuranceCurrent')) {
      this.current = Number(sessionStorage.getItem('insuranceCurrent'));
    } else {
      this.current = 0;
      sessionStorage.setItem('insuranceCurrent', 0);
    }
  },
  methods: {
    tabFun(num) {
      this.current = num;
      sessionStorage.setItem('insuranceCurrent', num);
    }
  }
};